import { withDefaultCurrency } from 'common/utils/formatUtils';
import {
  ProductStatus,
  RetirementPensionSavingsProductFragment,
  RetirementPensionSavingsProductInput,
} from 'generated/graphql';

export type MapRetirementPensionSavingsProductToInput = (
  product?: RetirementPensionSavingsProductFragment,
) => RetirementPensionSavingsProductInput;

export const mapRetirementPensionSavingsProductToInput: MapRetirementPensionSavingsProductToInput = (
  product = {
    creationTimestamp: new Date(),
    documents: [],
    enableFinancialAdvisorCare: true,
    enableNotifications: true,
    id: '',
    status: ProductStatus.Active,
    statusChangeDate: new Date(),
  },
) => {
  return {
    contractEndDate: product.contractEndDate,
    contractNumber: product.contractNumber,
    contractSignDate: product.contractSignDate,
    currentMarketValue: withDefaultCurrency(product.currentMarketValue),
    enableFinancialAdvisorCare: product.enableFinancialAdvisorCare,
    enableNotifications: product.enableNotifications,
    financialDetailsUpdatedAt: new Date(),
    guaranteedFund: product.guaranteedFund,
    institutionId: product.institution?.id,
    institutionName: product.institutionName,
    name: product.name,
    nonGuaranteedFund: product.nonGuaranteedFund,
    note: product.note,
    paymentInfo: {
      constantSymbol: product.paymentInfo?.constantSymbol,
      ibanForPayment: product.paymentInfo?.ibanForPayment,
      specificSymbol: product.paymentInfo?.specificSymbol,
      variableSymbol: product.paymentInfo?.variableSymbol,
    },
    paymentPeriod: {
      expectedAmount: withDefaultCurrency(product.paymentPeriod?.expectedAmount),
      periodCount: product.paymentPeriod?.periodCount,
      periodTypeCode: product.paymentPeriod?.periodTypeCode,
      referenceDate: product.paymentPeriod?.expectedDate,
    },
    status: product.status,
    statusChangeDate: product.statusChangeDate,
    voluntaryContribution: product.voluntaryContribution,
  };
};
